export default __webpack_public_path__ + "static/media/banner_products.19bbb245.jpg";